export default __webpack_public_path__ + "static/media/left.b51ba041.png";